export default "__VITE_ASSET__PS1QMk88__"